import { Box, Button, Grid, styled, Typography } from '@material-ui/core';

export const MainCont = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
  // flexDirection: 'column',
  display: 'flex',
  '& .family-profile-cont': {
    marginLeft: 'auto',
  },
  [theme.breakpoints.down(1260)]: {
    flexDirection: 'column',
    '& .family-profile-cont': {
      margin: '0 0 20px 0',
    },
  },
}));

export const MemberItemCont = styled(Box)(({ theme }) => ({
  '&:hover': {
    border: 'solid 1px #D4D4D4',
  },
  transition: '300ms',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: 130,
  height: 163,
  padding: '15px 0',
  margin: '0 20px 20px 0',
  backgroundColor: theme.palette.type === 'dark' ? '#0a0b15' : '#fff',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: '#2D343E',
  // borderImageSource: 'linear-gradient(253deg, #d51bff, #00d4ff)',
  // backgroundImage: 'linear-gradient(to bottom, #0c0f14, #0c0f14), linear-gradient(253deg, #d51bff, #00d4ff)',
  // backgroundOrigin: 'border-box',
  // backgroundClip: 'content-box, border-box',
  borderRadius: '8px !important',
}));

export const AddMemberButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: 130,
  height: 163,
  margin: '0 20px 20px 0',
  backgroundColor: theme.palette.type === 'dark' ? '#0a0b15' : '#fff',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: '#2D343E',
  borderRadius: '8px !important',

  '& path': {
    fill: '#3e8bff',
  },
}));
export const MemberPic = styled('img')(({ theme }) => ({
  width: 65,
  height: 89,
  borderRadius: 4,
  objectFit: 'contain',
}));
export const MemberName = styled(Typography)(({ theme }) => ({
  marginTop: 4,
  fontSize: 14,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  padding: 4,
  width: '100%',
  alignSelf: 'center',
  textAlign: 'center',
  overflow: 'hidden',
}));

export const MemberCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  overflow: 'auto',
  flex: 1,
  flexWrap: 'wrap',
}));

export const FamilyProfileCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  overflow: 'auto',
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  width: '60%',
  alignSelf: 'center',
  margin: 20,
  padding: 10,
}));
